module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_11.b4be8809.png";